import { Directive, HostListener, Input } from "@angular/core";

@Directive({
    selector: "[whatsAppContent]",
})
export class WhatsappContentDirective {
    @Input("whatsAppContent") content: string;

    @HostListener("click", ["$event"])
    onClick(event: any): void {
        event.stopPropagation();
        var win = window.open(
            `https://api.whatsapp.com/send?text=${this.content}`,
            "_blank"
        );
        win.focus();
    }
}
